import React from 'react';
import { Section } from './ui/Section';
export function SevenDayPlan() {
  const days = [{
    day: 'Día 1',
    task: 'Eliges idea (con Heylloyd + método 3P)'
  }, {
    day: 'Día 2',
    task: 'Creas la estructura completa'
  }, {
    day: 'Día 3',
    task: 'Expandes capítulos (sin escribir desde cero)'
  }, {
    day: 'Día 4',
    task: 'Preparas tu prompt para Gamma'
  }, {
    day: 'Día 5',
    task: 'Generas tu PDF y lo descargas'
  }, {
    day: 'Día 6',
    task: 'Armas tu oferta + mensajes para WhatsApp'
  }, {
    day: 'Día 7',
    task: 'Publicas, contactas y haces ventas'
  }];
  return <Section className="bg-brand-dark text-white" data-id="element-199">
      <div className="text-center mb-12" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-201">
          🗓️ El Plan “7 Días”
        </h2>
        <p className="text-gray-400" data-id="element-202">(para mamás ocupadas)</p>
      </div>

      <div className="max-w-3xl mx-auto" data-id="element-203">
        <div className="space-y-4" data-id="element-204">
          {days.map((item, i) => <div key={i} className="flex items-center bg-gray-800/50 p-4 rounded-xl border border-gray-700 hover:border-brand-pink/50 transition-colors" data-id="element-205">
              <div className="bg-brand-pink text-brand-dark font-bold px-3 py-1 rounded-md mr-4 min-w-[80px] text-center" data-id="element-206">
                {item.day}
              </div>
              <div className="text-gray-200 font-medium" data-id="element-207">{item.task}</div>
            </div>)}
        </div>

        <div className="text-center mt-10" data-id="element-208">
          <p className="text-2xl font-bold text-white" data-id="element-209">
            No necesitas perfección. <br data-id="element-210" />
            <span className="text-brand-pink" data-id="element-211">Necesitas terminar.</span>
          </p>
        </div>
      </div>
    </Section>;
}